<template>
  <div>
    <HeaderKuesioner />
    <section class="service-wrapper py-5">
      <div class="container">
        <div class="bg-line"></div>
        <div class="row mt-5">
          <div class="col-12 border-bottom px-4 py-2">
            <div class="row d-flex justify-content-center">
              <div class="col-md-12">
                <survey :survey="survey" class="px-4"></survey>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Konfirmasi sebelum submit -->
    <b-modal
      ref="confirm-modal"
      title="Konfirmasi Pengisian"
      @ok="doSubmit"
      ok-title="Ya, Kirim"
      cancel-title="Periksa Lagi"
      ok-variant="success"
    >
      <div class="text-center mb-3">
        <i class="bx bx-check-shield" style="font-size:48px;color:#003E29"></i>
      </div>
      <p class="text-center"><strong>{{ dataAlumni.nama_lengkap }}</strong> ({{ dataAlumni.npm }})</p>
      <p class="text-center">Apakah Anda yakin data yang diisi sudah benar? Data akan tersimpan dan dapat dilihat di Dashboard Anda.</p>
    </b-modal>

    <!-- Sukses -->
    <b-modal
      ref="success-modal"
      hide-footer
      title="Berhasil Mengisi Tracer Study"
      :no-close-on-backdrop="true"
    >
      <div class="d-block text-center">
        <i class="bx bxs-badge-check" style="font-size:64px;color:#003E29"></i>
        <h4 class="mt-2">Terima Kasih!</h4>
        <p>Data tracer study Anda telah berhasil disimpan.</p>
        <button class="btn btn-success mt-3" @click="goToDashboard">Lihat Dashboard</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import HeaderKuesioner from "@/components/hero/HeaderKuesioner.vue";
import * as SurveyVue from "survey-vue";
// import "bootstrap/dist/css/bootstrap.css";
var Survey = SurveyVue.Survey;
Survey.cssType = "bootstrap";

import * as widgets from "surveyjs-widgets";
import { init as customWidget } from "@/components/customwidget";
import SurveyService from "@/services/survey.service";

// widgets.icheck(SurveyVue);
widgets.select2(SurveyVue);
widgets.inputmask(SurveyVue);
widgets.jquerybarrating(SurveyVue);
widgets.jqueryuidatepicker(SurveyVue);
widgets.nouislider(SurveyVue);
widgets.select2tagbox(SurveyVue);
widgets.sortablejs(SurveyVue);
widgets.ckeditor(SurveyVue);
widgets.autocomplete(SurveyVue);
widgets.bootstrapslider(SurveyVue);
customWidget(SurveyVue);

SurveyVue.Serializer.addProperty("question", "tag:number");

import { json } from "@/models/question";

export default {
  components: {
    Survey,
    HeaderKuesioner
  },
  data() {
    return {
      survey: {},
      dataAlumni: {},
      id: this.id,
      pendingSubmit: null
    };
  },
  computed: {
    // currentAlumni() {
    //   return this.$store.state.survey.alumni.data;
    // }
  },
  created() {
    const surveyState = this.$store.state.survey.survey;
    if (!surveyState || !surveyState.elements) {
      this.$router.push("/kuesioner");
      return;
    }
    this.dataAlumni = this.$store.state.survey.alumni.data;
    if (!this.dataAlumni || !this.dataAlumni.id_profil) {
      this.$router.push("/kuesioner");
      return;
    }

    this.survey = new SurveyVue.Model(surveyState.elements);
    this.id = surveyState.id;

    const savedProgress = this.$store.state.survey.surveyProgress;
    if (savedProgress && Object.keys(savedProgress).length > 0) {
      this.survey.data = { ...savedProgress, prodi: this.dataAlumni.kode_prodi };
    } else {
      this.loadLastSurvey();
    }
  },
  mounted() {
    if (!this.survey || !this.survey.onComplete) return;

    this.survey.onValueChanged.add(function (sender) {
      this.$store.dispatch("survey/saveSurveyProgress", Object.assign({}, sender.data));
    }.bind(this));

    this.survey.onCompleting.add(function (sender, options) {
      options.allowComplete = false;
      this.pendingSubmit = Object.assign({}, sender.data);
      this.$refs["confirm-modal"].show();
    }.bind(this));

    this.survey.onComplete.add(function () {
    }.bind(this));
  },
  methods: {
    doSubmit() {
      if (!this.pendingSubmit) return;
      this.$store.dispatch("survey/saveSurveyProgress", {});
      var submitData = {
        data: {
          alumni: this.dataAlumni,
          elements: this.pendingSubmit
        }
      };
      SurveyService.surveyResults(this.id, submitData)
        .then(function (res) {
          if (res.data.surveys == this.dataAlumni.id_profil) {
            this.$refs["success-modal"].show();
          }
        }.bind(this))
        .catch(function (error) {
          console.error(error);
          alert("Gagal menyimpan data. Silakan coba lagi.");
        });
    },
    goToDashboard() {
      this.$refs["success-modal"].hide();
      this.$router.push("/alumni/dashboard");
    },
    loadLastSurvey() {
      SurveyService.getLastSurveyResult(this.dataAlumni.id_profil)
        .then(function (res) {
          if (res.data && res.data.data && Object.keys(res.data.data).length > 0) {
            this.survey.data = Object.assign({}, res.data.data, { prodi: this.dataAlumni.kode_prodi });
          } else {
            this.survey.data = { prodi: this.dataAlumni.kode_prodi };
          }
        }.bind(this))
        .catch(function () {
          this.survey.data = { prodi: this.dataAlumni.kode_prodi };
        }.bind(this));
    }
  }
};
</script>

<style scoped>
/* @import url('https://fonts.cdnfonts.com/css/glegoo'); */

.sv_main {
  font-family: "Glegoo", sans-serif;
  font-size: 0.8rem;
  line-height: normal;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_page_title {
  font-size: 2em;
}

.sv_main .sv_container .sv_body .sv_next_btn {
  border-radius: 5px;
  background-color: #8f1212;
  color: #fff;
  padding: 10px 28px !important;
  width: 120px !important;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.container {
  margin: 20px auto;
  padding: 0;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 6px 10px 23px -4px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 6px 10px 23px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 6px 10px 23px -4px rgba(0, 0, 0, 0.75);
}

.bg-line {
  background-color: #003e29;
  height: 10px;
  margin-bottom: 20px;
}

.forms-inputs {
  position: relative;
}

.forms-inputs span {
  position: absolute;
  top: -18px;
  left: 30px;
  background-color: #fff;
  padding: 5px 10px;
  font-size: 15px;
}

.forms-inputs input {
  height: 50px;
  border: 2px solid #eee;
}

.forms-inputs input:focus {
  box-shadow: none;
  outline: none;
  border: 2px solid #010d4a;
}

.btn {
  height: 50px;
}

.success-data {
  display: flex;
  flex-direction: column;
}

.bxs-badge-check {
  font-size: 90px;
}

@media only screen and (max-width: 480px) {
  .forms-inputs input {
    height: 70px;
    font-size: 0.7rem;
  }

  .forms-inputs select {
    height: 70px;
    font-size: 0.7rem;
  }

  .forms-inputs span {
    font-size: 0.8rem;
  }
  .sv_main {
    font-size: 0.4rem;
  }
}
</style>
